interface ContainsHandle {
  handle: string
}

export function sortByHandle<T extends ContainsHandle>(handles: string[]) {
  return (a: T, b: T) => handles.indexOf(a.handle) - handles.indexOf(b.handle)
}
